import React, { Fragment, useState } from 'react';
import { Anchor, Button, Upload } from '@keplerco/core';
import { useAppActions, useAppState } from '../../../../overmind';
import { IBulkUploadProps } from './freemium-bulk-upload.models';

export function BulkUpload({ bulkUploadType, setData, onValidate, onCancel }: IBulkUploadProps): JSX.Element {

  const { freemiumAccount } = useAppState();
  const actions = useAppActions();

  const [selectedFile, setSelectedFile] = useState<File | null>(null);
  const [errorMessage, setErrorMessage] = useState<string>();
  const [isLoading, setIsLoading] = useState(false);

  return (
    <Fragment>
      <Upload
        description="Drop your file here or <strong>Browse</strong"
        accept={['application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', 'text/csv']}
        error={errorMessage}
        onChange={files => {
          setSelectedFile(files[0]);
          setErrorMessage('');
          setData(undefined);
        }}
      />

      <div style={{ marginTop: 30, display: 'flex', justifyContent: 'space-between' }}>
        <Anchor onClick={() => onCancel()}>Cancel</Anchor>

        <Button
          type="button"
          disabled={!selectedFile}
          filled
          isLoading={isLoading}
          onClick={async () => {
            if (isLoading) return;
            if (!selectedFile) return;
            if (!freemiumAccount) return;

            if (selectedFile.size === 0) {
              setErrorMessage('The file you selected is empty. Please select a valid file.');
              return;
            }

            setIsLoading(true);

            const validationResult = await actions.bulkUploadValidate({
              file: selectedFile,
              companySlug: freemiumAccount.companySlug,
              bulkUploadType: bulkUploadType,
            });

            if (validationResult.error) {
              setErrorMessage(validationResult.error.detail);
              setIsLoading(false);
              return;
            }

            if (validationResult.data?.rows) {
              setData({ rows: validationResult.data.rows });
              onValidate();
            } else {
              setErrorMessage('No valid rows found, please add some data.');
            }

            setIsLoading(false);
          }}
        >
          Validate
        </Button>
      </div>
    </Fragment>
  );
}

